/* ============================================================
   KP ANALYTICS BEACON — the transport theme-analytics.js deliberately omits.

   Install as assets/kp-analytics-beacon.js and load it with defer, AFTER
   theme-analytics.js.

   Subscribes to the `kp:analytics` CustomEvent bus already emitted by
   theme-analytics.js and forwards batches to the first-party collector
   (/kpa/collect), which is a Cloudflare Worker on this domain. Server API
   secrets never appear here; the public GA4 web measurement ID is owned by
   kp-remarketing.js so it can create an attributed browser session.

   Human-intent gate: nothing is sent until the visitor produces a trusted
   input event, matching the existing pixel gate in layout/theme.liquid.
   Automated page loads therefore generate no analytics at all, which is the
   behaviour the merchant asked for ("fire only if i believe its not bot").
   Events raised before that point are queued, not discarded, so a genuine
   visitor's page_view is not lost.
   ============================================================ */
(function () {
  var storeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cfgEl = document.getElementById('kp-analytics-config');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.token || !cfg.ts) return;

  var MAX_QUEUE = 40;
  var FLUSH_MS = 4000;
  var queue = [];
  var released = false;
  var timer = null;
  var capabilityPending = false;
  var capabilityUpdated = 0;
  var restoredPage = false;

  function measurementContext() {
    return window.kpTrackingPolicy ? window.kpTrackingPolicy.context() : undefined;
  }

  function refreshPixelCapability() {
    if (capabilityPending || Date.now() - capabilityUpdated < 30 * 60 * 1000) return;
    capabilityPending = true;
    try {
      fetch('/kpa/session', {
        method:'POST', headers:{'Content-Type':'application/json'},
        credentials:'same-origin', keepalive:true,
        body:JSON.stringify({ts:cfg.ts, token:cfg.token, client_id:CID,
          release:releaseReason, signals:botSignals(),
          measurement_context:measurementContext(),
          ga_client_id:CID, ga_session_id:SID,
          attribution:attribution(), consent_evidence:consentEvidence(),
          meta:{fbp:gaCookie('_fbp'), fbc:gaCookie('_fbc')}})
      }).then(function (r) { if (!r.ok) throw new Error('session unavailable'); return r.json(); })
        .then(function (data) {
          if (!data.capability || !/^v1\./.test(data.capability)) return;
          document.cookie = '_kp_pixel_cap=' + encodeURIComponent(data.capability) +
            '; path=/; max-age=' + Math.min(Number(data.max_age) || 0, 7200) + '; SameSite=Lax; Secure';
          document.cookie = '_kp_pixel_cap_cid=' + encodeURIComponent(CID) +
            '; path=/; max-age=' + Math.min(Number(data.max_age) || 0, 7200) + '; SameSite=Lax; Secure';
          capabilityUpdated = Date.now();
        }).catch(function () {}).then(function () { capabilityPending = false; });
    } catch (_) { capabilityPending = false; }
  }

  /* client_id must be stable per browser for GA4 to stitch a session together,
     but it is not an identifier we choose or that identifies a person — a
     random value stored locally is exactly what gtag does. */
  /* FIRST_VISIT / SESSION_NEW (17 Oct 2026): with no browser tag, GA4 only
     learns "new user" and "new session" from the Worker's opener hit, and the
     opener can only say so if this script tells it. gtag sets _fv=1 when it
     had to create its cookie; this is the same test on our own id. Without
     it GA4 created no first_visit, New users read 0 and Realtime showed every
     visitor's source as "(not set)". */
  var FIRST_VISIT = 0, SESSION_NEW = 0;
  function clientId() {
    try {
      var k = 'kp_cid';
      var v = localStorage.getItem(k);
      if (!v) {
        v = (Date.now() ^ (Math.random() * 1e9 | 0)).toString(36) + '.' +
            (Math.random() * 1e9 | 0).toString(36);
        localStorage.setItem(k, v);
        FIRST_VISIT = 1;
      }
      document.cookie = "_kp_cid=" + v + "; path=/; max-age=" + (60 * 60 * 24 * 365) + "; SameSite=Lax; Secure";
      return v;
    } catch (e) {
      var fallback = gaCookie('_kp_cid');
      if (!fallback) { fallback = 'nostore.' + (Math.random() * 1e9 | 0).toString(36); FIRST_VISIT = 1; }
      document.cookie = "_kp_cid=" + fallback + "; path=/; max-age=" + (60 * 60 * 24 * 365) + "; SameSite=Lax; Secure";
      return fallback;
    }
  }

  /* GA4-style session (17 Oct 2026): this id IS the GA4 session id now that
     the browser carries no GA4 tag. Shared across tabs and ended by 30 minutes
     of inactivity, like gtag's own, so opening a product in a new tab stays
     one session. Refreshed on every page. */
  function sessionId() {
    var v = gaCookie('_kp_sid');
    if (!/^\d{10}$/.test(v || '')) { v = String(Math.floor(Date.now() / 1000)); SESSION_NEW = 1; }
    try { document.cookie = "_kp_sid=" + v + "; path=/; max-age=1800; SameSite=Lax; Secure"; } catch (e) {}
    return v;
  }

  /* Prefer GA4's OWN identifiers when the Google tag has published them.
     ----------------------------------------------------------------------
     kp-remarketing.js configures GA4 and writes gtag's real client_id and
     session_id to _kp_ga_cid / _kp_ga_sid. Server events must carry those
     exact values, otherwise GA4 files them under a different user and they do
     not inherit the browser session's source/medium — which is the entire
     point of putting the tag back.

     Falls back to our own ids when the tag has not loaded yet (it waits for a
     trusted interaction). Those early events land unstitched, which is better
     than losing them. Re-read on every send, so once gtag loads mid-visit the
     rest of the session stitches correctly. */
  function gaCookie(n) {
    try {
      var m = document.cookie.match('(^|;\\s*)' + n + '=([^;]*)');
      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) { return ''; }
  }

  var CID = clientId();
  var SID = sessionId();
  var started = Date.now();
  /* ENGAGEMENT TIME (17 Oct 2026). GA4 adds up engagement_time_msec across
     events as the time engaged SINCE THE LAST EVENT; gtag sent exactly that,
     plus a final ping on leave. With no browser tag this script is the only
     source, so every event carries the visible time not yet reported and
     leaving the page sends one kp_engagement event with the remainder. That
     keeps engaged sessions and average engagement time real. */
  /* Engaged = visible AND focused, which is how gtag counts it: a window
     left open beside another app accrues nothing. Visible-only counting
     (17-22 Oct 2026) reported hours of "engagement" from idle desktop tabs
     and pushed GA4's average session length past an hour. One delta is
     also capped at 30 minutes, GA4's own ceiling per event. */
  function engActive() {
    return document.visibilityState === 'visible' &&
      (typeof document.hasFocus !== 'function' || document.hasFocus());
  }
  var engVisibleSince = engActive() ? started : 0;
  var engTotal = 0, engReported = 0;
  function engagementNow() { return engTotal + (engVisibleSince ? Date.now() - engVisibleSince : 0); }
  function engagementDelta() { var now = engagementNow(); var d = now - engReported; engReported = now; return Math.max(1, Math.min(d, 1800000)); }
  function engTick() {
    if (engActive()) { if (!engVisibleSince) engVisibleSince = Date.now(); }
    else if (engVisibleSince) { engTotal += Date.now() - engVisibleSince; engVisibleSince = 0; }
  }
  document.addEventListener('visibilitychange', engTick);
  window.addEventListener('focus', engTick);
  window.addEventListener('blur', engTick);

  /* PRISJAKT / PriceSpy click id (13 Aug 2026).
     Prisjakt appends ?pjclid=<uuid>_<sig> to the landing URL and attributes a
     purchase to that click for up to 30 DAYS. Shopify's own landing_site holds
     only the FIRST landing URL of a session, so it cannot carry a click made
     days earlier in an earlier session — hence a 30-day first-party cookie,
     mirrored into cart attributes below so the ORDER WEBHOOK (which reports the
     conversion server-side) receives it whenever the order is placed. */
  function prisjaktClickId() {
    try {
      var m = location.search.match(/[?&]pjclid=([^&#]+)/i);
      if (m && m[1]) {
        var v = decodeURIComponent(m[1]);
        document.cookie = '_kp_pjclid=' + encodeURIComponent(v) +
          '; path=/; max-age=' + (60 * 60 * 24 * 30) + '; SameSite=Lax; Secure';
        return v;
      }
      var c = document.cookie.match(/(?:^|;\s*)_kp_pjclid=([^;]+)/);
      return c ? decodeURIComponent(c[1]) : '';
    } catch (e) { return ''; }
  }
  var PJCLID = prisjaktClickId();

  /* Keep Google identifiers typed. The old _kp_gclid cookie could contain a
     braid, so it cannot safely seed an offline GCLID import. New cookies carry
     the exact parameter name and the original click time for up to 90 days. */
  function googleClicks() {
    var result = {};
    var params;
    try { params = new URL(location.href).searchParams; } catch (_) { return result; }
    var fresh = ['gclid', 'gbraid', 'wbraid'].some(function (k) { return params.get(k); });
    var newClick = fresh && (!gaCookie('_kp_google_click_ts') || ['gclid', 'gbraid', 'wbraid'].some(function(k) {
      return (params.get(k) || '') !== gaCookie('_kp_google_' + k);
    }));
    ['gclid', 'gbraid', 'wbraid'].forEach(function (k) {
      try {
        var value = params.get(k) || '';
        var key = '_kp_google_' + k;
        if (newClick) {
          if (value && /^[A-Za-z0-9._~-]{1,200}$/.test(value)) {
            result[k] = value;
            document.cookie = key + '=' + encodeURIComponent(value) + '; path=/; max-age=7776000; SameSite=Lax; Secure';
          } else document.cookie = key + '=; path=/; max-age=0; SameSite=Lax; Secure';
        } else result[k] = gaCookie(key);
      } catch (_) {}
    });
    if (newClick) {
      document.cookie = '_kp_google_click_ts=' + Math.floor(Date.now() / 1000) + '; path=/; max-age=7776000; SameSite=Lax; Secure';
      document.cookie = '_kp_gclid=; path=/; max-age=0; SameSite=Lax; Secure';
    }
    result.ts = gaCookie('_kp_google_click_ts');
    return result;
  }
  var GOOGLE_CLICKS = googleClicks();

  // Record explicit choices; absence is unknown, never an invented grant.
  function consentEvidence() {
    var v = {}, cp;
    try {
      cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.currentVisitorConsent === 'function') v = cp.currentVisitorConsent() || {};
    } catch (_) {}
    function state(x) { return x === 'yes' ? 'granted' : x === 'no' ? 'denied' : 'unknown'; }
    var ad = state(v.marketing), sharing = state(v.sale_of_data);
    // Shopify's allowed methods also account for configured regional rules.
    try { if (sharing === 'unknown' && cp && typeof cp.saleOfDataAllowed === 'function') {
      var allowedSharing = cp.saleOfDataAllowed();
      sharing = allowedSharing === true ? 'granted' : allowedSharing === false ? 'denied' : 'unknown';
    } } catch (_) {}
    var matching = ad === 'denied' || sharing === 'denied' ? 'denied' : ad === 'granted' && sharing === 'granted' ? 'granted' : 'unknown';
    return {analytics_storage:state(v.analytics), ad_storage:ad,
      ad_user_data:matching, ad_personalization:matching,
      observed_at:Date.now(), source:'shopify_customer_privacy'};
  }

  /* ------------------------------------------------------------------------
     Traffic source, on every page view.

     The Worker has always logged gclid/source/medium/referrer, but it reads
     them from `attribution`, and only the checkout pixel ever sent that — so
     every storefront row in the dashboard showed blank columns and there was
     no way to see where visitors came from. This computes the same first/last
     touch the pixel does, so page views carry their origin too.

     First touch is written once and never overwritten; last touch updates
     whenever a new signal arrives. A visitor arriving on an ad, browsing, then
     returning direct still shows the ad as first touch. Internal navigation
     carries no signal, so it inherits whatever is stored rather than
     overwriting the real source with "(direct)".
     ---------------------------------------------------------------------- */
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'epik', 'oppref', 'pjclid'];

  function currentTouch() {
    var q = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var i = p.indexOf('=');
      // Ignore a malformed parameter without losing other campaign fields.
      try {
        var k = decodeURIComponent(i < 0 ? p : p.slice(0, i)).toLowerCase();
        if (k) q[k] = i < 0 ? '' : decodeURIComponent(p.slice(i + 1).replace(/\+/g, ' ')).slice(0, 200);
      } catch (e) {}
    });
    var ref = document.referrer || '';
    var src = '', med = '';
    if (q.gclid || q.gbraid || q.wbraid) { src = 'google'; med = 'cpc'; }
    else if (q.msclkid) { src = 'bing'; med = 'cpc'; }
    else if (q.fbclid) { src = 'facebook'; med = 'paid_social'; }
    else if (q.ttclid) { src = 'tiktok'; med = 'paid_social'; }
    else if (q.oppref) { src = 'chatgpt'; med = 'paid'; }
    else if (q.utm_source) { src = q.utm_source; med = q.utm_medium || 'referral'; }
    else if (ref) {
      try {
        var h = new URL(ref).hostname.replace(/^www\./, '');
        if (h && h.indexOf('kneepillow.co.uk') === -1) {
          src = h;
          med = /google|bing|yahoo|duckduckgo|ecosia|brave/i.test(h) ? 'organic' : 'referral';
        }
      } catch (e) {}
    }
    if (!src) return null; /* no signal — do not overwrite a real source */
    var t = {
      source: src, medium: med,
      campaign: q.utm_campaign || '', term: q.utm_term || '', content: q.utm_content || '',
      referrer: ref.slice(0, 500),
      /* 1000 not 300: gclid sits at the end of Google Ads URLs and was being
         truncated off the stored landing that gtag now reads as page_location. */
      landing: location.href.slice(0, 1000),
      ts: Math.floor(Date.now() / 1000)
    };
    CLICK_IDS.forEach(function (k) { if (q[k]) t[k] = q[k]; });
    return t;
  }

  // KP attribution: latest eligible non-direct touch, retained for 30 days.
  function eligibleTouch(t) {
    if (!t || !t.source || /^(\(direct\)|\(none\)|\(not set\))$/i.test(t.source)) return false;
    var h = String(t.source).toLowerCase().replace(/^https?:\/\//, '').split('/')[0].replace(/^www\./, '');
    if (/^(?:.*\.)?kneepillow\.co\.uk$/.test(h) ||
        /^(?:payments\.klarna\.com|pay\.klarna\.com|pay\.shopify\.com|checkout\.shopify\.com|checkout\.shopifycs\.com|checkout\.stripe\.com|hooks\.stripe\.com)$/.test(h) ||
        /^(?:.*\.)?paypal\.com$/.test(h)) return false;
    var age = Math.floor(Date.now() / 1000) - Number(t.ts);
    return Number.isFinite(age) && age >= -300 && age <= 30 * 86400;
  }

  function persistTouch() {
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem('_kp_attr_web') || '{}') || {}; } catch (e) {}
    if (!eligibleTouch(stored.first)) delete stored.first;
    if (!eligibleTouch(stored.last)) delete stored.last;
    var touch = restoredPage ? null : currentTouch();
    if (eligibleTouch(touch)) {
      if (!stored.first) stored.first = touch;
      // Repeated events on the same page do not extend a stored click's life.
      if (!stored.last || stored.last.landing !== touch.landing ||
          stored.last.source !== touch.source || stored.last.medium !== touch.medium ||
          stored.last.campaign !== touch.campaign) stored.last = touch;
    }
    try { localStorage.setItem('_kp_attr_web', JSON.stringify(stored)); } catch (e) {}
    return stored;
  }
  // Persist before the remarketing script reads the browser touch.
  var storedTouch = persistTouch();
  function syncAttributionToCart(restored) {
   try {
    if (document.querySelector('[data-kp-finder-market-gate]')) return;
    var current = storedTouch;
    if (restored) {
      // BFCache may restore a page from before a newer campaign visit. Read
      // the latest saved touch; do not recapture this older page's URL.
      try { current = JSON.parse(localStorage.getItem('_kp_attr_web') || '{}') || {}; } catch (_) {}
    }
    var cartTouch = eligibleTouch(current.last) ? current.last : eligibleTouch(current.first) ? current.first : {};
    var cartAttrs = { _kp_cid: CID, _kp_sid: SID };
    if (PJCLID) cartAttrs._kp_pjclid = PJCLID;
    ['gclid', 'gbraid', 'wbraid'].forEach(function(k) {
      cartAttrs['_kp_google_' + k] = gaCookie('_kp_google_' + k) || '';
    });
    cartAttrs._kp_google_click_ts = gaCookie('_kp_google_click_ts') || '';
    // Retire the ambiguous legacy attribute; typed fields above are authoritative.
    cartAttrs._kp_gclid = '';
    // Explicit empty values remove stale attributes when a campaign expires.
    ['source', 'medium', 'campaign', 'term', 'content'].forEach(function(k) {
      cartAttrs['_kp_utm_' + k] = String(cartTouch[k] || '').slice(0, 100);
    });
    cartAttrs._kp_attr_ts = String(cartTouch.ts || '');
    cartAttrs._kp_attr_landing = String(cartTouch.landing || '').slice(0, 1000);
    cartAttrs._kp_attr_referrer = String(cartTouch.referrer || '').slice(0, 500);
    ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid', 'oppref'].forEach(function(k) {
      cartAttrs['_kp_attr_' + k] = String(cartTouch[k] || '').slice(0, 200);
    });
    // Queued with the other page-load cart writers (kp-cart-attributes): on a
    // first visit parallel writes each create their own cart and lose these.
    if (window.kpCartAttributes) window.kpCartAttributes(cartAttrs);
    else fetch(storeRoot + 'cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:cartAttrs}), keepalive:true
    }).catch(function () {});
   } catch (_) {}
  }
  // No session-wide success cache: a restored tab can have a replacement cart.
  syncAttributionToCart(false);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { restoredPage = true; syncAttributionToCart(true); } });
  /* A basket created by Add to basket (/cart/add.js before the first queued
     write returned) or replaced by Shop's cart sync has none of these
     attributes, so write them again once the add has succeeded. Both events
     fire for one add; the timer folds them into one write. */
  var resync;
  function resyncAfterAdd() { clearTimeout(resync); resync = setTimeout(function () { syncAttributionToCart(false); }, 50); }
  try {
    document.addEventListener('product-ajax:added', resyncAfterAdd);
    document.addEventListener('kp:analytics', function (e) { var d = e && e.detail; if (d && d.event === 'cart_add_success') resyncAfterAdd(); });
  } catch (_) {}

  function attribution() {
    var stored = persistTouch();
    if (!stored.first && !stored.last) {
      /* Genuinely direct: record it so the dashboard shows "(direct)" rather
         than an empty cell that looks like a tracking failure. */
      stored.last = {
        source: '(direct)', medium: '(none)',
        referrer: '', landing: location.href.slice(0, 1000),
        ts: Math.floor(Date.now() / 1000)
      };
    }
    return stored;
  }

  /* ------------------------------------------------------------------------
     Automation signals.

     Collected in the browser, scored in the Worker — so thresholds can be
     tuned by redeploying the Worker rather than pushing the theme and waiting
     on asset caches. Deliberately NOT a third-party library (BotD and friends
     mean another CDN script on every page, which is what we just removed).

     Each is a contradiction a real device cannot produce:
       webdriver      - true under Puppeteer/Playwright/Selenium
       zeroScreen     - headless browsers frequently report 0x0
       noTouch        - a phone user agent with zero touch points
       noOuter        - outerWidth 0 means no real window chrome
       noLangs        - navigator.languages empty; every real browser has one
       swMesa         - WebGL renderer is SwiftShader/llvmpipe/Mesa, i.e.
                        software rendering, the default in headless Chrome
       noCores        - hardwareConcurrency 0
     Individually several are weak, so the Worker requires a combination.
     Purchases are exempt from the verdict, so no sale can be lost to a
     false positive.
     ---------------------------------------------------------------------- */
  function botSignals() {
    var f = {};
    try { if (navigator.webdriver === true) f.webdriver = 1; } catch (e) {}
    try { if (!screen.width || !screen.height) f.zeroScreen = 1; } catch (e) {}
    try {
      var ua = navigator.userAgent || '';
      if (/iPhone|iPad|Android|Mobile/i.test(ua) && !(navigator.maxTouchPoints > 0)) f.noTouch = 1;
      if (/Chrome\//.test(ua) && !/Edg\/|OPR\//.test(ua) && !window.chrome) f.noChrome = 1;
      if (/HeadlessChrome/i.test(ua)) f.headlessUA = 1;
    } catch (e) {}
    try { if (!window.outerWidth) f.noOuter = 1; } catch (e) {}
    try { if (!navigator.languages || !navigator.languages.length) f.noLangs = 1; } catch (e) {}
    try { if (navigator.hardwareConcurrency === 0) f.noCores = 1; } catch (e) {}
    try {
      if (window.KPBrowserSignals) {
        var shared = window.KPBrowserSignals.webgl();
        if (shared.software) f.swRender = 1;
        if (shared.unavailable) f.noWebgl = 1;
        return f;
      }
      var c = document.createElement('canvas');
      var gl = c.getContext('webgl') || c.getContext('experimental-webgl');
      if (gl) {
        var dbg = gl.getExtension('WEBGL_debug_renderer_info');
        var r = dbg ? String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) || '') : '';
        if (/swiftshader|llvmpipe|mesa offscreen/i.test(r)) f.swRender = 1;
      } else {
        f.noWebgl = 1;
      }
    } catch (e) {}
    return f;
  }

  /* ONE VISITOR, ONE SESSION (9 Oct 2026). gtag now adopts this script's
     client id (kp-remarketing reads _kp_cid), so users can no longer split.
     Sessions still can: gtag mints its own session id and publishes it to
     _kp_ga_sid only after gtag.js has loaded, while the first flush (trusted
     input or 2.5s dwell) often came first and went out under this script's
     own session id. So, when gtag is expected on this page (policy allowed or
     still deciding, analytics consent not denied), hold the flush for up to
     GTAG_WAIT_MS in 250ms steps until gtag is live AND has published its
     session id. If gtag never arrives (blocked, automation, slow network),
     the batch goes out as before with ga_live 0 and the Worker opens the
     session. Unload and hidden-tab flushes (useBeacon) never wait. */
  var GTAG_WAIT_MS = 3000;
  var gtagWaitSince = 0;
  function gtagExpected() {
    /* Server-only GA4 (17 Oct 2026): no browser GA4 session id to wait for. */
    return false;
    try {
      var p = window.kpTrackingPolicy;
      if (p && typeof p.allowed === 'function' && typeof p.pending === 'function' && !p.allowed() && !p.pending()) return false;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) return false;
    } catch (e) {}
    return true;
  }
  function gtagReady() { return window.__kpGaLive === 1 && !!gaCookie('_kp_ga_sid'); }
  function send(useBeacon) {
    if (!queue.length) return;
    if (!useBeacon && !gtagReady() && gtagExpected()) {
      if (!gtagWaitSince) gtagWaitSince = Date.now();
      if (Date.now() - gtagWaitSince < GTAG_WAIT_MS) {
        if (!timer) timer = setTimeout(function () { timer = null; send(false); }, 250);
        return;
      }
    }
    if (released) refreshPixelCapability();
    var batch = queue.splice(0, queue.length);
    /* SESSION EXPIRY (23 Oct 2026). Every hit extends the 30-minute session
       cookie, as gtag's does, and once it has lapsed the next hit starts a
       new session. Before this the page-load id lived on in memory for as
       long as the tab did: a tab picked up again the next day stretched one
       GA4 session to 21 hours. Engagement left over from the lapsed session
       has no real session to land in, so it is dropped. */
    var sidBefore = SID; SID = sessionId();
    if (SID !== sidBefore) {
      SESSION_NEW = 1; engTotal = 0; engReported = 0; engVisibleSince = engActive() ? Date.now() : 0;
      batch = batch.filter(function (e) { return e.name !== 'kp_engagement'; });
      if (!batch.length) return;
    }
    /* Sent once per new session; the Worker opens the GA4 session on that
       batch (its page_view, or its first event when there is none). */
    var sessionNew = SESSION_NEW; SESSION_NEW = 0;
    var payload = JSON.stringify({
      measurement_context: measurementContext(),
      ts: cfg.ts,
      token: cfg.token,
      client_id: CID,
      session_id: SID,
      /* 1 when this page load created the client id / session id above; the
         Worker turns these into GA4's _fv / _nsi on the session-opener hit. */
      first_visit: FIRST_VISIT,
      session_new: sessionNew,
      pixel_capability:gaCookie('_kp_pixel_cap'),
      provenance_client_id:CID,
      consent_evidence:consentEvidence(),
      meta:{fbp:gaCookie('_fbp'), fbc:gaCookie('_fbc')},
      /* Did gtag ACTUALLY run on this pageview? kp-remarketing sets
         window.__kpGaLive only after gtag configured (past looksAutomated +
         consent). The Worker uses this — not the cid format — to decide whether
         it must open the GA4 session itself via /g/collect, which fixes the
         returning-visitor case where an old numeric cid survives but gtag was
         suppressed this visit. */
      ga_live: (window.__kpGaLive === 1 ? 1 : 0),
      /* Is the session id above gtag's own (1) or this script's fallback (0)?
         With ga_live 1 and ga_sid_known 0 the Worker must not forward over
         Measurement Protocol, or GA4 would open a second session. */
      ga_sid_known: 1,
      /* 'input:scroll' / 'input:pointerdown' / ... = a real trusted gesture
         happened. 'dwell' = the page was visible 2.5s and NOTHING was touched. */
      release: releaseReason,
      /* DID A GTAG HIT ACTUALLY REACH GOOGLE? (21 Aug 2026, diagnostic only.)
         ga_live proves gtag.js LOADED, not that its page_view landed. A blocker
         that allows googletagmanager.com but blocks google-analytics.com leaves
         gtag apparently healthy while the session is never created — GA4 then
         shows the visit as "(not set)" with a BLANK landing page, because the
         only events it ever receives are the Worker's MP events. 29 such
         sessions on 21 Aug, against 17 Google ad clicks that had gtag's own cid.

         Resource Timing sees the collect request whatever transport gtag picks
         (fetch, XHR, image, sendBeacon are all reported). Timing is safe: this
         runs at flush, 2.5-6.5s after load, while gtag hits within ~1s of
         config — so an absent entry means blocked, not "too early".

         NOTHING BRANCHES ON THIS YET. It is logged so tomorrow's number is
         measured rather than argued: acting on a false positive would open a
         duplicate session for every healthy gtag visitor, which is worse than
         the hole it would close. */
      ga_hit: (function () {
        try {
          var es = performance.getEntriesByType('resource');
          for (var i = 0; i < es.length; i++) {
            if (/(^|\.)(google-analytics\.com|analytics\.google\.com)/.test(es[i].name)
                && /[\/.]collect/.test(es[i].name)) return 1;
          }
        } catch (e) { return -1; }   /* -1 = could not measure, not "blocked" */
        return 0;
      })(),
      attribution: attribution(),
      signals: botSignals(),
      events: batch
    });

    /* sendBeacon survives page unload, which plain fetch does not — that is
       what makes checkout_begin and outbound product_click reliable. */
    if (useBeacon && navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(cfg.endpoint, new Blob([payload], { type: 'application/json' }))) return;
      } catch (e) { /* fall through to fetch */ }
    }
    try {
      fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
        credentials: 'omit'
      }).catch(function () {});
    } catch (e) {}
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; send(false); }, FLUSH_MS);
  }

  document.addEventListener('kp:analytics', function (e) {
    var d = e && e.detail;
    if (!d || !d.event) return;

    var params = {};
    Object.keys(d).forEach(function (k) {
      if (k === 'event') return;
      var v = d[k];
      if (v === undefined || v === null || v === '') return;
      params[k] = typeof v === 'number' || typeof v === 'boolean' ? v : String(v).slice(0, 100);
    });
    params.engagement_time_msec = engagementDelta();
    params.page_location = location.href.slice(0, 400);
    params.page_referrer = (document.referrer || '').slice(0, 400);
    /* Without page_title GA4's "Page title and screen class" report is entirely
       "(not set)" — 36 of 36 views on 5 Aug 2026. Measurement Protocol does not
       infer it from the URL, so it has to be sent. */
    params.page_title = (document.title || '').slice(0, 300);

    queue.push({ name: d.event, params: params });

    /* GA4's e-commerce reports key on view_item with an items array — a
       page_view carrying product context does not populate them, which is why
       other pixels emit a separate product-view event. Derive it here from
       the same bus event rather than asking the theme to fire twice. Items
       are keyed by SKU (merchant decision, matches Merchant Center). Built
       explicitly because the generic copier above flattens objects to
       strings, which would destroy the items array. */
    if (d.event === 'page_view' && d.page_type === 'product' && d.product_sku) {
      queue.push({
        name: 'view_item',
        params: {
          currency: String((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP'),
          value: parseFloat(d.product_price || '0') || 0,
          items: [{ item_id: String(d.product_sku).slice(0, 100), price: parseFloat(d.product_price || '0') || 0, quantity: 1 }],
          page_location: location.href.slice(0, 400),
          page_title: (document.title || '').slice(0, 300)
        }
      });
    }

    if (queue.length > MAX_QUEUE) queue.splice(0, queue.length - MAX_QUEUE);
    if (released) schedule();
  });

  /* Dwell gate — not an interaction gate.
     ----------------------------------------------------------------------
     The original gate required a trusted click/scroll before anything was
     sent. That filtered bots as a side effect but also erased every real
     visitor who lands, reads and leaves without touching the page, which is
     why GA4 showed a fraction of true traffic.

     Removing it let scrapers in: they render the page, take the product data
     and leave, producing page_view + view_item and nothing else — no
     product_click, no variant_change, no search, no cart. That is exactly the
     pattern the merchant identified on 5 Aug 2026.

     So the gate is now TIME, not interaction. A scraper loads and leaves in
     well under a second; a person reading a product page is still there after
     two and a half. Whichever comes first releases the queue:
       - a trusted input event (fast path for someone who clicks immediately)
       - or 2.5s of the page actually being visible

     Time spent in a background tab does not count, so a prefetched or
     preloaded page never releases on its own. Nothing is discarded while
     waiting — events queue and flush on release, so a real visitor's page_view
     is never lost, only delayed.

     navigator.webdriver is checked first: it is true under Puppeteer,
     Playwright and Selenium, and most scrapers never bother to hide it.
     ---------------------------------------------------------------------- */
  try { if (navigator.webdriver === true) return; } catch (e) {}

  var DWELL_MS = 2500;
  var visibleSince = document.visibilityState === 'visible' ? Date.now() : 0;
  var dwelled = 0;
  var dwellTimer = null;

  /* WHICH PATH RELEASED THE QUEUE (23 Aug 2026).
     The gate opens on EITHER a trusted input event OR 2.5s of visible dwell,
     and until now nothing recorded which. That single bit is the difference
     between "a person looked at this page" and "something rendered it and
     left", and it is the exact question the merchant is asking about paid
     clicks that produce page_view + view_item and nothing else. Recorded, not
     acted on: this changes no gating and drops nothing. */
  var releaseReason = 'dwell';

  function release() {
    if (released) return;
    released = true;
    refreshPixelCapability();
    if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
    EVENTS.forEach(function (n) { window.removeEventListener(n, onInput, true); });
    schedule();
  }

  /* INP (9 Oct 2026): release() fetches pixel capability and schedules the flush. Doing that inside the
     shopper's first pointerdown delayed the paint of that tap (about 40 ms at 4x CPU). The reason is still
     recorded from the first trusted event; the work runs in the next task, after the tap has painted. */
  var releasePending = false;
  function onInput(ev) {
    if (released || releasePending) return;
    if (ev && ev.isTrusted) {
      releaseReason = 'input:' + String(ev.type || '?');
      releasePending = true;
      /* SECOND-PAGE RULE (15 Oct 2026, merchant-approved). The first real
         gesture leaves a 30-minute first-party cookie; kp-tracking-policy
         forwards it as prior_gesture, and the Worker then measures a visitor
         on a temporary-cohort browser string from the next page on, even
         though the first page arrived cold. A scroll is no longer in EVENTS:
         window.scrollTo() fires a trusted scroll and the proxy fleet used
         exactly that; a person's scroll always comes with a wheel, touch, key
         or mouse-down first, which still release and still set the cookie. */
      try { document.cookie = '_kp_gesture=' + Date.now() + '; path=/; max-age=1800; SameSite=Lax; Secure'; } catch (e) {}
      setTimeout(release, 0);
    }
  }
  var EVENTS = ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'wheel'];
  EVENTS.forEach(function (n) { window.addEventListener(n, onInput, true); });

  function startDwell() {
    if (released || dwellTimer) return;
    visibleSince = Date.now();
    dwellTimer = setTimeout(release, Math.max(0, DWELL_MS - dwelled));
  }
  function pauseDwell() {
    if (released || !dwellTimer) return;
    clearTimeout(dwellTimer); dwellTimer = null;
    dwelled += Date.now() - visibleSince;
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') startDwell(); else pauseDwell();
  });
  if (document.visibilityState === 'visible') startDwell();

  function leave() {
    if (!released) return;
    if (engagementNow() - engReported >= 1000) {
      queue.push({ name: 'kp_engagement', params: { engagement_time_msec: engagementDelta(),
        page_location: location.href.slice(0, 400), page_title: (document.title || '').slice(0, 300) } });
    }
    send(true);
  }
  window.addEventListener('pagehide', leave, { capture: true });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') leave();
  });
})();
